import { render, staticRenderFns } from "./ServiceProviderDetailComponent.vue?vue&type=template&id=b507c904&"
import script from "./ServiceProviderDetailComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports